import { css } from '@/styled-system/css';

export const drawerHeaderStyles = css.raw({
  'flex': '0 0 auto',
  'paddingBlock': 'default',
  'paddingInlineStart': 'layout.tight',
  'paddingInlineEnd': 'layout.looser',

  '& > .c11n_heading': {
    color: 'text.neutral',
    textStyle: 'heading-xs',
  },
});
